import { useEffect, useState } from 'react';
import { CHANNEL_TABS, CHANNEL_NEWS } from '@/mocks/data';

export default function Channels() {
  const [tab, setTab] = useState('娱乐');

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail;
      if (detail && CHANNEL_TABS.includes(detail)) setTab(detail);
    };
    window.addEventListener('heigua-channel', handler);
    return () => window.removeEventListener('heigua-channel', handler);
  }, []);

  const items = CHANNEL_NEWS[tab] || [];
  const mid = Math.ceil(items.length / 2);
  const left = items.slice(0, mid);
  const right = items.slice(mid);

  const Timeline = ({ list }: { list: { time: string; dot: string }[] }) => (
    <ol className="space-y-1">
      {list.map((it, i) => (
        <li key={i} className="group relative flex gap-3 rounded-lg p-2.5 transition-colors hover:bg-background-50 md:p-3">
          <span className="flex h-6 w-12 shrink-0 items-center justify-center rounded-md bg-background-200 text-xs font-semibold tabular-nums text-foreground-700">
            {it.time}
          </span>
          <span className="relative mt-1.5 flex h-2 w-2 shrink-0 items-center justify-center">
            <span className="absolute h-2 w-2 rounded-full bg-primary-400 opacity-30"></span>
            <span className="relative h-1.5 w-1.5 rounded-full bg-primary-500"></span>
          </span>
          <p className="min-w-0 flex-1 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
            {it.dot}
          </p>
        </li>
      ))}
    </ol>
  );

  return (
    <section id="channels" className="scroll-mt-24 bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 md:mb-8">
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>
              按频道浏览
            </p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-[34px]">频道快讯</h2>
          </div>
          <p className="max-w-md text-xs leading-relaxed text-foreground-500 md:text-sm">
            每天分频道滚动更新短讯，按时间线排布，快速浏览你关心的那一块瓜田。
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200 p-3 md:px-4">
            <div className="flex w-full items-center gap-1 overflow-x-auto rounded-full bg-background-100 p-1 scrollbar-none md:w-auto">
              {CHANNEL_TABS.map((c) => (
                <button
                  key={c}
                  type="button"
                  onClick={() => setTab(c)}
                  className={`shrink-0 cursor-pointer rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
                    tab === c ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-700'
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-1.5 text-xs font-semibold text-secondary-700">
              <i className="ri-live-line"></i>
              {tab}频道 · 今日已更新 {items.length} 条
            </div>
          </div>

          <div className="grid grid-cols-1 gap-x-8 p-4 md:grid-cols-2 md:p-5">
            <Timeline list={left} />
            {right.length > 0 && <Timeline list={right} />}
          </div>
        </div>
      </div>
    </section>
  );
}